import { useEffect, useState } from 'react';

import { FALLBACK_TOP_NAV_RESPONSE } from '../constants';
import { getServerUrl } from '../utils/getServerUrl';
import { isEmptyObject } from '../utils/isEmptyObject';
import type { TopBarLinksType } from '../constants';

export const useQueryTopNav = ({
  currentAccountId,
  customUserId,
}: {
  currentAccountId?: number;
  customUserId?: number;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [topNav, setTopNav] = useState<TopBarLinksType>(
    FALLBACK_TOP_NAV_RESPONSE
  );

  useEffect(() => {
    let apiSubscribed = true;

    async function getTopnavData() {
      const serverUrl = getServerUrl();
      const topnavUrl = `${serverUrl}/api/v3/navigation-data/topbar`;

      try {
        setIsLoading(true);
        const response = await fetch(topnavUrl, {
          credentials: 'include',
          headers: {
            'x-current-account-id': currentAccountId?.toString() || '',
            'x-customuser-id': customUserId?.toString() || '',
          },
        });
        if (!response.ok) {
          throw new Error('Response was not OK');
        }

        if (apiSubscribed) {
          const json = await response.json();
          const { data } = json;
          if (!isEmptyObject(data)) setTopNav(data);
          // If we don't explicitly set state here, UniversalNav tests fail in the pipeline.
          // A number of tests never exit the loading state.
          setIsLoading(false);
        }
      } catch (error) {
        if (apiSubscribed) {
          setTopNav(FALLBACK_TOP_NAV_RESPONSE);
        }
      } finally {
        if (apiSubscribed) {
          setIsLoading(false);
        }
      }
    }

    getTopnavData();

    return () => {
      apiSubscribed = false;
    };
  }, [currentAccountId, customUserId]);

  return { isLoading, topNav };
};
